import { queryKey } from '@client-info/features/chat/hooks';
import { orpc } from '@client-info/utils/orpc';
import type { QueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { InvalidLinkPage } from './-components/InvalidLinkPage';

export const load = (accessCode: string, queryClient: QueryClient) =>
  queryClient
    .ensureQueryData(
      orpc.chat.byAccessCode.queryOptions({
        queryKey: [...queryKey, accessCode],
        input: { accessCode },
      }),
    )
    .catch(() => {
      throw new Error('Error loading chat');
    });

export const Route = createFileRoute('/chat/$accessCode')({
  loader: ({ params, context: { client: queryClient } }) =>
    load(params.accessCode, queryClient),
  errorComponent: InvalidLinkPage,
});
